import React, { useState, useEffect } from "react"
import "./EmergencyAccessProtocol.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowDown } from "@fortawesome/free-solid-svg-icons"
import { useSelector } from "react-redux"
import PDFViewer from "components/PdfViewer/PdfViewer"
import { getCenterDetail } from "core/services/api"

export default function EmergencyAccessProtocol() {
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [centerDetails, setCenterDetails] = useState<any>({})

  useEffect(() => {
    if (userDetail?.currentCenter?.centerId) {
      getCenterDetail(userDetail?.currentCenter?.centerId)
        .then((res: any) => {
          setCenterDetails(res)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [userDetail])

  function renderTreeView(obj: any) {
    return (
      <div className="p-2">
        <div
          className="title"
          dangerouslySetInnerHTML={{ __html: obj?.title }}
        />
        {/* <div className="title">{obj?.title}</div> */}
        {obj?.child?.length > 0 ? (
          <FontAwesomeIcon
            size="lg"
            className="download-icon"
            icon={faArrowDown}
          />
          // <img
          //   src="../../assets/images/down_arrow.svg" className="down-arrow-icon"
          //   alt="down-arrow"
          // />
        ) : null}
        {obj?.child?.length > 1 ? (
          <div className="d-flex justify-content-center">
            <div
              className="top-border"
              style={{ width: obj?.child?.length === 3 ? "100%" : "50%" }}
            />
          </div>
        ) : null}
        <div className={`d-flex justify-content-center `}>
          {obj?.child?.map((each: any) => (
            <div className={`${obj?.child?.length > 1 ? "col-6" : "col-12"}`}>
              {obj?.child?.length > 1 ? (
                <FontAwesomeIcon
                  size="lg"
                  className="download-icon"
                  icon={faArrowDown}
                />
                //       <img
                //   src="../../assets/images/down_arrow.svg" className="down-arrow-icon"
                //   alt="down-arrow"
                // />
              ) : null}
              {renderTreeView(each)}
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="emergency-access-protocol-wrapper">
      {/* <div className="header-text">Emergency</div> */}
      {/* <img width="100%" src={`/assets/images/Care_Protocol_${userDetail?.currentCenter?.centerName}.jpg`} alt={`Care_Protocol_${userDetail?.currentCenter?.centerName}`} /> */}
      <PDFViewer url={centerDetails?.accessCareProtocol?.blobUrl} />
      {/* <div className="protocol-wrapper text-center">
        {renderTreeView(accessCareJson)}
      </div> */}
    </div>
  )
}
